import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ViewMoreBtn from "../../components/ViewMoreBtn";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { arrowRight } from "../../../../assets/svg/Svg";
import { LuFilter } from "react-icons/lu";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getVouchers } from "../../../../redux/slices/voucherSlice";
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";

const Voucher = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [category, setCategory] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const { vouchers, refetch } = useSelector((state) => state.voucherSlice);

  const prevProps = useRef({ refetch }).current;

  useEffect(() => {
    if (prevProps.refetch != refetch) {
      dispatch(getVouchers(setIsLoading));
    }
    return () => {
      prevProps.refetch = refetch;
    };
  }, [refetch]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(getVouchers(setIsLoading));
  }, []);

  console.log(vouchers, "vouchers");

  const columns = [
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      sortable: true,
    },
    {
      name: "Voucher Code",
      selector: (row) => row.voucherCode,
      sortable: true,
    },
    {
      name: "Voucher-Access",
      selector: (row) => row.voucherAccess,
      sortable: true,
    },
    {
      name: "Voucher-Parent",
      selector: (row) => row.voucherParent,
      sortable: true,
    },
    {
      name: "Discounted Amount",
      selector: (row) => row.discountPrice,
      sortable: true,
    },
    {
      name: "Valid Date",
      selector: (row) => row.validDate,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => row.action,
    },
  ];

  const data = vouchers.map((voucher) => {
    const isDeleted = voucher.deleted;

    const iconStyle = {
      minWidth: "max-content",
      cursor: isDeleted ? "not-allowed" : "pointer",
      opacity: isDeleted ? 0.5 : 1,
    };

    return {
      id: 0,
      voucherCode: voucher?.voucherCode,
      voucherAccess:
        voucher?.voucherAccess?.charAt(0).toUpperCase() +
        voucher?.voucherAccess?.slice(1).toLowerCase(),
      voucherParent: voucher?.user?.[0]?.fullName ? (
        <span
          onClick={() => navigate(`/user/${voucher?.user?.[0]?._id}`)}
          style={{
            cursor: "pointer",
            color: "#be9528",
          }}
        >
          {voucher?.user?.[0]?.fullName}
        </span>
      ) : (
        "For All"
      ),
      discountPrice: `$ ${voucher?.discountPrice}`,
      validDate: voucher?.validDate
        ? new Date(voucher?.validDate).toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
          })
        : "One Time",
      status: (
        <label
          className={
            voucher?.active == false
              ? "badge badge-danger"
              : "badge badge-success"
          }
        >
          {voucher?.active == false ? "Inactive" : "Active"}
        </label>
      ),
      createdAt: new Date(voucher.createdAt)
        .toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
        })
        .replace(/\//g, "-"),
      action: (
        <div className="d-flex">
          <FiEdit
            size={16}
            onClick={
              !isDeleted
                ? () => navigate(`/voucher/${voucher._id}/update`)
                : null
            }
            style={iconStyle}
          />
          &nbsp;&nbsp;&nbsp;&nbsp;
          <AiOutlineDelete
            size={19}
            onClick={
              !isDeleted
                ? () => {
                    setDeleteId(voucher?._id);
                    setDeleteModal(true);
                  }
                : null
            }
            style={iconStyle}
          />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <ViewMoreBtn redirectUrl={`/voucher/${voucher._id}`} />
        </div>
      ),
    };
  });

  const filteredData = data.filter((item) => {
    const name =
      typeof item?.voucherCode === "string"
        ? item?.voucherCode?.toLowerCase()
        : "";

    return (
      name.includes(searchText.toLowerCase()) &&
      (category ? item.status.props.children === category : true)
    );
  });

  const handleSearch = (value) => {
    setSearchText(value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const handleCategoryChange = (value) => {
    setCategory(value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  const exportUsersToCsv = () => {
    const csvContent = convertToCsvString(filteredData);
    const encodedUri = encodeURI(csvContent);
    const blob = new Blob([csvContent], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "queries.csv";
    link.click();
  };

  const convertToCsvString = (data) => {
    const rows = [];
    const headers = Object.keys(data[0]);
    rows.push(headers.join(","));

    data.forEach((item) => {
      const values = headers.map((header) => item[header]);
      rows.push(values.join(","));
    });

    return rows.join("\n");
  };

  return (
    <>
      {isLoading ? (
        <div className="w-100 d-flex">
          <div class="spinner-border text-primary mx-auto" role="status"></div>
        </div>
      ) : (
        <>
          <div>
            <div className="page-header">
              <h3 className="page-title">Vouchers</h3>
            </div>
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body py-4">
                    <>
                      {/* <button onClick={handleClearRows}>Clear Selected Rows</button> */}
                      <DataTable
                        // title={<h6 className="card-title">Users List</h6>}
                        columns={columns}
                        data={filteredData}
                        pagination
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[
                          10, 20, 30, 50, 100, 200, 500,
                        ]}
                        // paginationComponent={customPagination}
                        highlightOnHover
                        pointerOnHover
                        subHeader
                        subHeaderAlign="left"
                        subHeaderComponent={
                          <>
                            <Row className="mb-3 w-100">
                              <Col
                                md={8}
                                className="d-flex align-items-start flex-column gap-2"
                              >
                                <span className="d-flex align-items-center gap-2 me-3 filterby_label">
                                  <LuFilter />
                                  Filter By :
                                </span>
                                <div className="table_filter">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by name"
                                    value={searchText}
                                    onChange={(e) =>
                                      handleSearch(e.target.value)
                                    }
                                  />
                                  <select
                                    className="form-control h-54px w-auto"
                                    value={category}
                                    onChange={(e) =>
                                      handleCategoryChange(e.target.value)
                                    }
                                  >
                                    <option selected value="">
                                      Status
                                    </option>
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                  </select>
                                </div>
                              </Col>

                              <Col
                                md={4}
                                className="d-flex align-items-end justify-content-end"
                              >
                                <button
                                  className="btn_primary_outline_sm me-2"
                                  onClick={() => navigate("/voucher/create")}
                                >
                                  Create Voucher
                                </button>
                                <button
                                  className="btn_primary_outline_sm"
                                  disabled={!filteredData.length}
                                  onClick={exportUsersToCsv}
                                >
                                  Export CSV
                                </button>
                              </Col>
                            </Row>
                          </>
                        }
                      />
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Voucher;
